// Location-specific content for the detailed revenue estimate PDF.
// Sourced from the corresponding management landing pages.
export const CITY_DATA = {
  Manchester: {
    stats: [
      ["76%", "Average occupancy across our Manchester portfolio"],
      ["2.5m", "Overnight domestic trips each year"],
      ["No licence", "No short-let licensing scheme or night cap"],
    ],
    drivers: [
      ["Two Premier League clubs", "City and United fixtures all season. Matchday weekends typically run 2 to 3 times standard rates."],
      ["AO Arena", "21,000-seat sell-outs. Concert nights are the highest-earning nights of the month."],
      ["Universities and MediaCityUK", "80,000+ students plus corporate and production crews booking for weeks at a time."],
      ["The Christmas Markets", "The UK's biggest, and routinely the highest-revenue weeks of our year."],
    ],
  },
  Liverpool: {
    stats: [
      ["73%", "Average occupancy across our Liverpool portfolio"],
      ["67m", "Annual visitors to Liverpool and the region"],
      ["No cap", "No 90-night annual limit on short-lets"],
    ],
    drivers: [
      ["Premier League football", "Anfield and Everton's new stadium at Bramley-Moore Dock. Matchdays can command 2 to 3 times standard rates."],
      ["Grand National", "150,000+ visitors to Aintree each April, with 3 to 4 times standard rates during race week."],
      ["M&S Bank Arena", "Over 100 concerts and events a year, filling surrounding dates across the North West."],
      ["Universities and the waterfront", "70,000+ students bring steady midweek demand; the Royal Albert Dock peaks in summer."],
    ],
  },
  "Stoke-on-Trent": {
    stats: [
      ["68%", "Average occupancy across our Stoke-on-Trent portfolio"],
      ["2.8m", "Annual visitors to Stoke-on-Trent and the Potteries"],
      ["No cap", "No 90-night annual limit on short-lets"],
    ],
    drivers: [
      ["Stoke City FC — Bet365 Stadium", "Home matches bring thousands of visiting fans throughout the season. Match weekends command premium rates near the stadium and Hanley."],
      ["Staffordshire University", "Campuses in Stoke and Stafford enrol over 20,000 students, generating sustained demand from visiting families and graduations."],
      ["Trentham Gardens & Estate", "Over 1.5 million visitors a year to the gardens, shopping village and Monkey Forest, driving family tourism demand."],
      ["Excellent transport links", "Direct rail to London Euston, Manchester and Birmingham drives strong corporate and leisure visitor demand."],
    ],
  },
  _default: {
    stats: [
      ["35,000+", "Stays managed since 2019"],
      ["16+", "Platforms your listing goes live on"],
      ["48 hrs", "Payout after every check-in"],
    ],
    drivers: [
      ["Events and entertainment", "Concerts, sport and festivals create high-rate nights that dynamic pricing captures."],
      ["Business travel", "Weekday stays from corporate guests and contractors fill the gaps between leisure bookings."],
      ["Universities", "Open days, graduations and visiting families create reliable midweek demand."],
      ["Leisure breaks", "Weekends and school holidays drive the busiest months of the year."],
    ],
  },
};